import { render, staticRenderFns } from "./SySnackbar.vue?vue&type=template&id=a5491b50&scoped=true&"
import script from "./SySnackbar.vue?vue&type=script&lang=js&"
export * from "./SySnackbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5491b50",
  null
  
)

export default component.exports